namespace GeniuzPOS.Purchase {
    export interface PoPurInvoiceDtForm {
        PrRefDocNo: Serenity.StringEditor;
        PrLineId: Serenity.IntegerEditor;
        LineItemNo: Serenity.IntegerEditor;
        SupplierId: Serenity.LookupEditor;
        WhsId: Serenity.LookupEditor;
        ShopId: Serenity.StringEditor;
        SkuCode: Serenity.LookupEditor;
        SkuDesc: Serenity.StringEditor;
        UnitCost: Serenity.DecimalEditor;
        Qty: Serenity.DecimalEditor;
        UnitChange: Serenity.EnumEditor;
        PurUnit: Serenity.StringEditor;
        PurUnitPrice: Serenity.DecimalEditor;
        LastPurUnitPrice: Serenity.DecimalEditor;
        PurUnitRatio: Serenity.DecimalEditor;
        Remark: Serenity.StringEditor;
        BeforeDiscAmt: Serenity.DecimalEditor;
        DiscText: Serenity.StringEditor;
        DiscAmt: Serenity.DecimalEditor;
        ItemAmt: Serenity.DecimalEditor;
        AlocalteDiscAmt: Serenity.DecimalEditor;
        ItemNetAmt: Serenity.DecimalEditor;
        VatType: Serenity.StringEditor;
        VatCode: Serenity.LookupEditor;
        VatRate: Serenity.DecimalEditor;
        ItemVatAmt: Serenity.DecimalEditor;
        ItemExVatAmt: Serenity.DecimalEditor;
        ItemExciseTaxAmt: Serenity.DecimalEditor;
        ItemNetCostValue: Serenity.DecimalEditor;
        SalesVatTypes: Serenity.StringEditor;
    }

    export class PoPurInvoiceDtForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.PoPurInvoiceDt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PoPurInvoiceDtForm.init)  {
                PoPurInvoiceDtForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.LookupEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.EnumEditor;

                Q.initFormType(PoPurInvoiceDtForm, [
                    'PrRefDocNo', w0,
                    'PrLineId', w1,
                    'LineItemNo', w1,
                    'SupplierId', w2,
                    'WhsId', w2,
                    'ShopId', w0,
                    'SkuCode', w2,
                    'SkuDesc', w0,
                    'UnitCost', w3,
                    'Qty', w3,
                    'UnitChange', w4,
                    'PurUnit', w0,
                    'PurUnitPrice', w3,
                    'LastPurUnitPrice', w3,
                    'PurUnitRatio', w3,
                    'Remark', w0,
                    'BeforeDiscAmt', w3,
                    'DiscText', w0,
                    'DiscAmt', w3,
                    'ItemAmt', w3,
                    'AlocalteDiscAmt', w3,
                    'ItemNetAmt', w3,
                    'VatType', w0,
                    'VatCode', w2,
                    'VatRate', w3,
                    'ItemVatAmt', w3,
                    'ItemExVatAmt', w3,
                    'ItemExciseTaxAmt', w3,
                    'ItemNetCostValue', w3,
                    'SalesVatTypes', w0
                ]);
            }
        }
    }
}
